<template>
  <div class="py-3">
    <page-loading v-if="!item" />
    <page-title v-if="item" :title="pageTitle" />
    <hr />
    <div v-if="item" class="mt-3">
      <application-user-fields :item="item" v-on:submit="onSubmit" v-on:cancel="onCancel">
        <template v-slot:save>Save</template>
      </application-user-fields>
    </div>
    <hr />
    <b-button type="button" @click="onSpoof">Spoof</b-button>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ApplicationUserEdit",
  props: ['id'],
  data() {
    return {
      item: null
    };
  },
  computed: {
    pageTitle: function () {
      return 'User: ' + this.item.userName;
    }
  },
  methods: {
    load: function () {
      let url = '/api/applicationUser/' + this.id;

      axios
        .get(url)
        .then(response => {
          console.log(response);

          // TODO: Check for 200?

          this.item = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    onSpoof: function (evt) {
      axios.post('/api/account/spoofLogin',
      {
        "userId": this.id
      })
      .then(response => {
        if (response.status == 200) {
          if (response.data.requiresVerificationCode) {
            this.logInUsesTFA = true;
            return;
          }

          axios.defaults.headers.common['Authorization'] = "Bearer " + response.data.jwtToken;
          this.$root.$data.authenticatedUser.username = response.data.userName;
          this.$root.$data.authenticatedUser.id = response.data.id;
          this.$root.$data.authenticatedUser.roles = response.data.roles;

          localStorage.setItem('jwt', response.data.jwtToken);
          localStorage.setItem('username', response.data.userName);
          localStorage.setItem('id', response.data.id);
          localStorage.setItem('roles', JSON.stringify(response.data.roles));

          this.$router.push('/');
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    onCancel(evt) {
      this.$router.push('/applicationUser');
    },
    onSubmit(evt) {
      this.$bvModal.msgBoxOk('Sorry, you can\'t save users.', {
        title: 'Not Supported'
      });
      // let url = '/api/ApplicationUser/' + this.id;

      // axios
      //   .put(url, this.item)
      //   .then(response => {
      //     console.log(response);

      //     this.item = response.data;

      //     this.$parent.showToast('Your changes to "' + this.item.userName + '" were saved successfully.', {
      //       title: 'Saved',
      //       variant: 'success',
      //       autoHideDelay: 5000
      //     });

      //     this.$router.push('/applicationUser');
      //   })
      //   .catch(error => {
      //     console.log(error);

      //     let errorMessage = 'Unable to save "' + this.item.name + '". An unknown error occurred.';

      //     if (error.response.status == 400)
      //       errorMessage = 'Unable to save "' + this.item.name + '". The data you provided could not be validated.';
      //     else if (error.response.status == 403)
      //       errorMessage = 'Unable to save "' + this.item.name + '". You are not logged in or do not have access.';
      //     else if (error.response.status == 409)
      //       errorMessage = 'Unable to save "' + this.item.name + '". The item has been edited since you loaded the page. Reload this page to get the latest changes.';

      //     this.$parent.showToast(errorMessage, {
      //       title: 'Error Saving',
      //       variant: 'danger',
      //       autoHideDelay: 5000
      //     });
      //   });
    }    
  },
  mounted () {
    this.load();
    // Use this instead of the previous line to test the "Loading" bar
    //window.setTimeout(this.load, 3000);
  }
};
</script>